const CLARITY_PROJECT_ID = 'vz5gaska7a';

export function initClarity() {
  if (!import.meta.env.PROD) return;

  const w = window as unknown as Record<string, unknown>;
  w['clarity'] =
    w['clarity'] ||
    function (...args: unknown[]) {
      ((w['clarity'] as { q?: unknown[] }).q =
        (w['clarity'] as { q?: unknown[] }).q || []).push(args);
    };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
  document.head.appendChild(script);
}
